export const environment = {
  production: true,
  // puerto: 9999,
  puerto: 1444,
  // rutaWS: `http://192.168.1.55:`
  // rutaWS: `https://192.168.1.48:`
  rutaWS: `https://node.g2k.es:`
  // rutaWS: `https://192.168.1.115:`
};
